import tippy from 'tippy.js';
import { layer }  from '~/assets/icons/js/layer';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('form');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,  
            tagName:'form',
            attributes:{
                "data-slg-type":"C-FORM-LAYERS",
                "data-slg-form-layers": 2,
                "data-slg-layer-active":0,
                "data-slg-layer-prev":"",
                "data-slg-form-layer-animation":false
            },
            style: {
                "min-width": '100px',
                "min-height": '100px'
            },
            // draggable:false,
            // droppable: false,
            components: model => {
                let components = [];
                let layers = model.get('attributes')['data-slg-form-layers'];
                for (let i = 0; i < layers; i++) {

                    let layer = {
                        type:"C-LAYER",
                    };

                    components.push(layer);
                }
                return components;
            },
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-FORM-LAYERS")
                return { type:'C-FORM-LAYERS' }
        }
    });

    var view = VIEW.extend({

        init: function () {
          let component = this.model;
          this.listenTo(component, 'change:attributes:data-slg-form-layers', this.addLayer);
          this.listenTo(component, 'change:attributes:data-slg-layer-active', this.changeLayer);
        },
        onRender() {
            let component = this.model;
            this.createCustomMenu();

            let layers = component.components();
            console.log(layers);
            for (let i = 0; i < layers.length; i++) {
                const layer = layers.at(i);

                layer.setStyle({
                    display: (i == 0) ? "block":"none"
                })
                
            }
        },
        changeLayer:function(component){
            let attributes = component.getAttributes();
            let layer_active = attributes['data-slg-layer-active'];
            let layer_prev = attributes['data-slg-layer-prev'];
            console.log(layer_active);
            component.components().at(layer_active).setStyle({ 
                display: 'block' 
            });

            component.components().at(layer_prev).setStyle({ 
                display: 'none' 
            });
            
        },
        addLayer:function(component){
            let attributes = component.getAttributes();
            
            component.append({
                type:"C-LAYER"
            });
        },
        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
         createCustomMenu: function(){
            let el = this.el;
            var self = this;
            let component = this.model;
            let wrapperEl = editor.getWrapper().view.el;
            let tooltip = /*html*/
            `
            <div id="template">
                <ul class="list-toggle">
                    <li class="item add" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fas fa-plus fa-1x"></i>
                    </li>
                    <li class="item next" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fas fa-cog fa-1x"></i>
                    </li>
                </ul>
            </div>
            ` 
            const instance = tippy(el, {
                content: tooltip,
                allowHTML: true,
                trigger: 'click',
                theme: 'light',
                interactive: true,
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    let itemConfig = instance.popper.querySelector('.item.next');
                    itemConfig.addEventListener('click',(e) =>{
                        e.preventDefault();
                        let attributes = component.getAttributes();
                        let layer_active = attributes['data-slg-layer-active'];
                            layer_active = parseInt(layer_active);
                        let form_layers = attributes['data-slg-form-layers'];
                            form_layers = parseInt(form_layers);
                        component.setAttributes({
                            ...attributes,
                            "data-slg-layer-active": (layer_active + 1 == form_layers) ? 0 : layer_active + 1,
                            "data-slg-layer-prev": layer_active
                        });

                        instance.hide();
                    });

                    let itemAdd = instance.popper.querySelector('.item.add');
                    itemAdd.addEventListener('click',(e) =>{
                        e.preventDefault();
                        let attributes = component.getAttributes();
                        let form_layers = attributes['data-slg-form-layers'];
                            form_layers = parseInt(form_layers);
                        component.setAttributes({
                            ...attributes,
                            "data-slg-form-layers": form_layers + 1
                        });

                        instance.hide();
                    });

                },
            });
            
            
        },

         
    });

    DOMC.addType('C-FORM-LAYERS', {
      model:model,
      view:view,
    });

    // BM.add('B-FORM-LAYERS', {
    //     label:"FORM LAYERS",
    //     content: { 
    //       type: 'C-FORM-LAYERS',
    //      },
    //     media:layer,
    //     category:"ADVANCE COMPONENT",
    // });
};
  